import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M10.739 10.158a2.35 2.35 0 00-.879-.176v2.342c.293-.234.586-.41.879-.644v-1.522z" />
        <Path d="M33.05 18.649c-.176-.703-.762-1.172-1.464-1.289-.41-.058-.762.235-.762.586-.058.351.234.703.586.761.175 0 .293.117.351.235.059.175 0 .468-.293.644-.117.117-.585.351-1.405.175-.234-2.752-1.757-5.211-4.158-6.851-.878 2.108-2.986 3.572-5.446 3.572-3.22 0-5.855-2.635-5.855-5.856v-.234a4.498 4.498 0 00-2.694-1.288v3.162c-2.342 1.347-4.04 3.396-4.743 5.739H5v4.86h2.167c.82 2.694 2.928 4.977 5.797 6.266V32h3.28v-1.874a13.506 13.506 0 004.332 0V32h3.28v-2.87c3.455-1.58 5.856-4.567 6.09-8.022 1.23.176 1.932-.234 2.284-.527.702-.351.995-1.171.82-1.932zm-22.663-.879a.925.925 0 01-.937-.937c0-.527.41-.936.937-.936.527 0 .937.41.937.936.059.527-.41.937-.937.937z" />
        <Path d="M20.46 6a4.698 4.698 0 00-4.686 4.685 4.698 4.698 0 004.685 4.684 4.698 4.698 0 004.685-4.684A4.699 4.699 0 0020.459 6zm.175 4.333c.234.117 1.347.41 1.347 1.464 0 .352-.117 1.171-1.23 1.23v.644h-.469v-.585c-.41-.059-.76-.176-.995-.469-.234-.234-.351-.586-.351-.995h.878c0 .644.468.76.703.76.175 0 .585-.058.585-.526 0-.469-.41-.586-.644-.703-.234-.117-1.347-.351-1.347-1.464 0-.351.176-1.112 1.23-1.23v-.702h.468v.702c.352.059 1.172.235 1.172 1.464h-.879c.059-.585-.41-.76-.585-.76-.469 0-.527.35-.527.526 0 .351.41.527.644.644z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
